import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/images/Screenshot 2024-06-12 151437.png";
import projImg2 from "../assets/images/sss.png";
import projImg3 from "../assets/images/poonam.png";
import projImg4 from "../assets/images/bytecraft.png";
import projImg7 from "../assets/images/drunl.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Projects = () => {
  const projects = [
    {
      title: "Poonam Enterprise",
      description: "CCTV & Surveillance Solutions Platform",
      imgUrl: projImg3,
      techStack: ["React", "Laravel", "PHP", "MySQL", "Bootstrap"],
      link: "https://thepoonamenterprises.in/",
      details:
        "Developed a production-ready business platform for selling CCTV systems and surveillance solutions. The system includes admin and customer dashboards, product management, inquiry handling, and responsive UI optimized for business leads.",
    },
    {
      title: "SoundScape",
      description: "E-Commerce Platform for Audio Products",
      imgUrl: projImg2,
      techStack: ["Quasar Framework", "JavaScript"],
      link: "https://github.com/mohitarora143/ProductRecommendationSystem.git",
      details:
        "Built a high-performance e-commerce platform featuring animated UI, responsive layouts, and real-time product filtering. Focused on user experience, smooth navigation, and optimized checkout flow.",
    },
    {
      title: "Deep Learning + Machine Learning",
      description: "Drunkenness Detection System",
      imgUrl: projImg7,
      techStack: ["Python", "TensorFlow", "Keras"],
      link:
        "https://drive.google.com/file/d/1I43Kqx5wjFPXHkw2CQPlLlSHSga46wgy/view?usp=sharing",
      details:
        "Developed a deep learning–based model to detect drunkenness levels using neural networks. The project demonstrates practical application of ML pipelines, model training, and evaluation using TensorFlow and Keras.",
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col xs={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Projects</h2>
                  <p>
                    A selection of real-world projects demonstrating my work in
                    full-stack web development and machine learning, focused on
                    scalable systems, clean UI, and production-ready solutions.
                  </p>

                  <Row>
                    {projects.map((project, index) => (
                      <ProjectCard
                        key={index}
                        title={project.title}
                        description={project.description}
                        imgUrl={project.imgUrl}
                        techStack={project.techStack}
                        link={project.link}
                        details={project.details}
                        style={{
                          borderRadius: "8px", // reduced from heavy radius
                        }}
                      />
                    ))}
                  </Row>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>

      <img
        className="background-image-right"
        src={colorSharp2}
        alt="background"
      />
    </section>
  );
};
